const OfferData = [
  {
    image:
      "https://spring-inspiration.com/wp-content/uploads/2018/11/Motion-Gray-1-ZK6CY2KKC4-1920x1200.jpg",
    title: "1",
    top: "",
    right: "",
  },
  {
    image: "https://upload.wikimedia.org/wikipedia/commons/8/86/Solid_grey.svg",
    title: "1",
    top: "30%",
    right: "70%",
  },
  {
    image: "https://upload.wikimedia.org/wikipedia/commons/8/86/Solid_grey.svg",
    title: "2",
    top: "0%",
    right: "25%",
  },
  {
    image: "https://upload.wikimedia.org/wikipedia/commons/8/86/Solid_grey.svg",
    title: "4",
    top: "-10%",
    right: "0%",
  },
  {
    image: "https://upload.wikimedia.org/wikipedia/commons/8/86/Solid_grey.svg",
    title: "5",
    top: "40%",
    right: "95%",
  },
  {
    image: "https://upload.wikimedia.org/wikipedia/commons/8/86/Solid_grey.svg",
    title: "6",
    top: "-5%",
    right: "80%",
  },
  {
    image: "https://upload.wikimedia.org/wikipedia/commons/8/86/Solid_grey.svg",
    title: "7",
    top: "40%",
    right: "10%",
  },
];

export default OfferData;
